import { types } from 'mobx-state-tree';

export const BulkUpdateResponse = types.model('BulkUpdateResponse', {
  invalidSellerAccounts: types.maybe(types.array(types.string),[]),
  allFailed: types.maybe(types.boolean, false),
});

export default BulkUpdateResponse;